import { EFonts } from 'libs/styles/styling';
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    value: string;
    autoComplete?: string;
    autoFocus?: boolean;
    placeholder?: string;
    type?: string;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    className?: string;
}

export const EventTextInput = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_EventTextInput className={props.className}>
            <S_Input
                value={value}
                autoComplete={props.autoComplete}
                autoFocus={props.autoFocus}
                placeholder={props.placeholder}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (props.onChange) {
                        props.onChange(e.target.value);
                    }
                }}
                type={props.type ?? 'text'}
                onBlur={props.onBlur}
            />
        </S_EventTextInput>
    );
};

export const S_EventTextInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const S_Input = styled.input`
    border-radius: 27px;
    font-family: ${EFonts.Regular};
    padding: 0px 20px;
    font-size: 15px;
    color: #000;
    min-width: 45px;
    resize: none;
    outline: none;
    height: 40px;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: none;
    background: #fafcfe;
    &&::placeholder {
        color: #696969;
    }
`;
